export default __webpack_public_path__ + "static/media/charles.33dcabfb.jpg";